<template>
    <div>
        <top-navbar></top-navbar>
<div>
  

<div class="container-fluid">
  <h6 class="manage-boder pt-2 font1 font-bold1"> <a class="decoration" to="/"> Home </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Spare Parts  </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Manage GRN  </h6>
 
  <h6 class="custom-maintitle "><b>Manage GRN</b></h6>

<div style="padding-top: 0px; margin-bottom: -10px; padding-bottom: 0px; border-bottom: 0px;"  class="navbar ">
  
  <div style="margin-top:-20px;" class="d-flex " >
 
    <b-input-group size="sm" style="width: 225px;">
            <b-form-input id="filter-input" v-model="filter" type="search" placeholder="Search">
            </b-form-input>
            
    </b-input-group>
    
</div>
  


<div  style="margin-top:-20px; margin-right: -2px;" class="d-grid gap-2 d-md-flex justify-content-md-end">


<button style="font-size: small;"  class="btn btn-primary btn-sm"><router-link class="decoration custom-btn"  to="/igrn/create"> Create GRN</router-link></button>



</div>
</div>




<div class="card ">
<div class="card-body">
 

  <b-table  responsive style="font-size: small;"  class=" table-striped table-hover "
      :items="grns"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
    
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      
      
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"

      show-empty
      small
      @filtered="onFiltered"
    >
   


      <template #cell(name)="row">
        {{ row.value.first }} {{ row.value.last }}
      </template>

       <template #cell(actions)="row">
        <!--<b-button class="custom-btn mr-1 mb-1" style="background-color: rgb(71, 144, 255);" size="sm" @click="row.toggleDetails">
          {{ row.detailsShowing ? 'Hide' : 'Show' }} 
        </b-button> -->
        <!-- <b-button style="background-color: rgb(71, 144, 255);"  size="sm"  class="mr-1 custom-btn">
          View
        </b-button> -->
        <button  style=" font-size: small;"
         @click="info(row.item.idGrn)" class="mr-1 btn custom-btn btn-primary btn-sm mb-1">
          View
        </button>
      
        <!-- <b-button style="background-color: rgb(71, 144, 255);"  size="sm"
         v-on:click="ViewLoad(row.item.idGrn)"  class="mr-1 custom-btn mb-1">
          View
        </b-button> -->
        <button style="font-size: small;" v-show="row.item.G_status==3"   class="mr-1 btn custom-btn btn-primary btn-sm mb-1">
          Print
        </button>
        <button @click="UpdateLoad(row.item.idGrn)" style=" font-size: small;" v-show="row.item.G_status==1" size="sm"  class="mr-1 btn custom-btn btn-primary btn-sm mb-1">
          Update
        </button>
        <button :disabled="isConfirmButtonDisabled"  @click="confirm(row.item.idGrn)" style="font-size: small;" v-show="row.item.G_status==1" size="sm"  class="mr-1 btn custom-btn btn-primary btn-sm mb-1">
          Confirm
        </button>
       
        <button style=" font-size: small;" v-show="row.item.G_status==1" size="sm"  class="mr-1 btn custom-btn btn-primary btn-sm mb-1">
          Cancel
        </button>
       
      </template>

      <template #row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
      </template>
    </b-table>
 <!-- model start -->
    <b-modal   :id="infoModal.id" :title="infoModal.content.G_grn_num"  hide-footer >
<div class=" ">
<div class="card">
  <div class="card-body">
      <table style="font-size: small; " class="table  table-sm  ">
       
       <tbody >

         <tr >
           <td style="border: 0px;" ><b>Id </b></td>
          <td style="border: 0px;">{{ infoModal.content.idGrn }}</td> 
         </tr>
         <tr>
           <td><b>GRN No. </b></td>
          <td>{{ infoModal.content.G_grn_num }}</td> 
         </tr>
         <tr>
           <td><b>Material Request Number </b></td>
          <td>{{ infoModal.content.request_po_no }}</td> 
         </tr>
        
         <tr>
           <td><b>Created Date </b></td>
          <td>{{ infoModal.content.G_created_date }}</td> 
         </tr>
         <tr>
           <td><b>Status </b></td>
          <td>{{ infoModal.content.status1 }}</td> 
         </tr>
         <tr>
           <td><b>Received Date </b></td>
          <td>{{ infoModal.content.G_received_date }}</td> 
         </tr>
         <tr>
           <td><b>Remarks </b></td>
          <td>{{ infoModal.content.G_remarks }}</td> 
         </tr>
        
          
       </tbody>


     </table>

<div   class="d-grid gap-2 d-md-flex justify-content-md-end mb-2">
<button  v-on:click="ViewLoad(infoModal.content.idGrn)"   class=" btn custom-btn btn-primary btn-sm mb-1"> More</button>
</div>
</div>
</div>
</div>  
      
    </b-modal>

    <!-- model end -->
    
      <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-5">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>

      

  
    
    

  

</div>
</div>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
        isConfirmButtonDisabled: false,
      
       
        grns:[],
        infoModal: {
          id: 'info-modal',
          title: '',
          content: {},
        },
       
        fields: [
          { key: 'G_grn_num', label: 'GRN No', sortable: true, sortDirection: 'desc' },
          { key: 'request_po_no', label: 'Material Request Number', sortable: true, class:'width-custom2', },
          { key: 'G_received_date', label: 'Received Date', sortable: true  },
          { key: 'G_created_date', label: 'Created Date', sortable: true  },
          { key: 'status1', label: 'Status', sortable: true  },
          
          { key: 'actions', label: 'Actions', class:'width-custom1', }
        ],

        
      


        
      }

    },
    computed: {
     
    },
    mounted(){
     
      
  this.loadGrn();


    },
methods : {

  async confirm(idgrn) {
    this.isConfirmButtonDisabled = true;
  
  try {
    const { data} = await  axios.post('http://localhost/Skygarden_vuejs/web/api/igrn/confirm?id='+idgrn,{userid:this.userid},{
      headers:{
        'Authorization':'Bearer '+this.access_token,
        'Content-type': 'application/json',
       
      }
     });
     console.log(data);
     if(data.status == 200){
      this.isConfirmButtonDisabled = false;
      this.loadGrn();
     }
     //this.infoModal.content = data.grn
     //this.$root.$emit('bv::show::modal', this.infoModal.id)
    
    
  } catch (error) {
    console.log(error.response);
  }
},

  // info(idgrn) {
  //   console.log(idgrn);
    
       
  //       this.infoModal.content = idgrn
  //       this.$root.$emit('bv::show::modal', this.infoModal.id)
  //     },
  //     resetInfoModal() {
  //       this.infoModal.title = ''
  //       this.infoModal.content = ''
  //     },

      async info(idgrn) {
  
    try {
      const { data} = await  axios.get('http://localhost/Skygarden_vuejs/web/api/igrn/view?id='+idgrn,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.infoModal.content = data.grn
       this.$root.$emit('bv::show::modal', this.infoModal.id)
      
      
    } catch (error) {
      console.log(error.response);
    }
  },


  ViewLoad(id) {
    
    this.$router.push('/igrn/view?id='+id);
  },
  UpdateLoad(id) {
    
    this.$router.push('/igrn/update?id='+id);
  },

  serchCustom(id) {

this.filterOn = id;
  },

  onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
  
  async loadGrn() {
    console.log(this.access_token);
    try {
      const { data} = await  axios.get('http://localhost/Skygarden_vuejs/web/api/igrn/index',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.grns = data.igrn;
       this.totalRows = this.grns.length;
      
    } catch (error) {
      console.log(error.response);
    }
  },
   

       


 
  


 


},

    components :{
        ContentFooter,
        TopNavbar
    },
  }

</script>
<style>
.text_right{
  text-align: right;
}
.width-custom3{
  width: 100px;
}
.width-custom4{
  width: 130px;
}
.width-custom5{
  width: 150px;
}
.width-custom6{
  width: 85px;
}
.width-custom7{
  width: 170px;
}
.width-custom8{
  width: 200px;
}

.font-size_def {
  font-size: small !important;
}

.width-custom2 {
    width: 250px !important;
} 

.btn-primary {
    color: #fff;
    background-color: #2642a7;
    border-color: #2642a7;

}
.btn-warning {
    color: #fff;
    background-color: #ffcc33;
    border-color: #ffcc33;

}
.wip-btn {
    color: #fff;
    background-color: #ff8f62;
    border-color: #ff8f62;
}
.wip-btn:hover {
    color: #fff;
    background-color: #fc5716;
    border-color: #fc5716;
}
.outsourced-btn {
  color: #fff;
    background-color: #a3766b;
    border-color: #a3766b;
}
.outsourced-btn:hover {
  color: #fff;
    background-color: #74301f;
    border-color: #74301f;
}
.custom-btn {
  color: white !important; 
  border: 1px !important;
}

.decoration{
      text-decoration: none;
      color:white !important;
    
    }


.width-custom2 {
  width: 175px;
}
.modal-dialog{
  margin-top: -60px;
}
@media only screen and (min-width: 768px) {
  .width-custom1 {
  width: 20%;
}
  
}


.bg-clr1{
  background-color: red !important;
}
 .mouse-cursor {
  cursor: pointer;
 }




.button-iffect:focus {
 background-color: red;
}

.table th {
  border-top: 0px !important;
}
  
.font-bold1{
        font-weight: bold !important;
      }
.font1{
        font-size: 13px !important;
     
      }
 .manage-boder{
      
  border-bottom: 3px solid #1b2753 !important ;
    border-top: 1px solid #1b2753 !important ;
      
      padding-top: 10px !important;
      padding-left: 20px;
      border-radius: 0px;
      padding-bottom: 10px !important;
      font-size: 13px !important;
  background-color: #1b2753 ;

      
      }

      .btn-outline-primary {
        color: #2642a7 ;
        border-color: #2642a7;
      }
      .btn-outline-primary:hover {
        color: white ;
        border-color: #2642a7;
        background-color: #2642a7;
      }
      .btn-outline-primary:active {
        color: white ;
        border-color: #2642a7;
        background-color: #2642a7;
      }

      .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
    color: #fff;
    background-color: #2642a7;
    border-color: #2642a7;
}

      .color-heading{
        color: #2642a7;
       
      }

      .page-item.active .page-link {
        z-index: 3;
      color: #fff;
      background-color: #1b2753;
      border-color: #1b2753;
      }
      .page-item{
        color: #1b2753;
      }
      .page-link{
        color: #1b2753;
      }
      .page-link:hover{
        color: #1b2753;
      }
     
.custom-icon{
  width: 65px;
  
}
.custom-icon2{

}
.custom-form{
 margin-top: 1px !important;
 margin-bottom: 1px !important;
}
.custom-label{
 font-size: small !important;
  color: black !important;

  
  
}
.custom-label2{
 font-size: small !important;
 color: white !important;
 
 

  
  
}




.table-striped tbody tr:nth-of-type(odd)>* {
  background-color: #ededed;
}
.table-hover tbody tr:hover {
    color: #212529;
    background-color: #ededed;
}
.table-striped>tbody>tr:nth-of-type(odd)>* {
  --bs-table-accent-bg: #ededed !important;
}
.table-hover>tbody>tr:hover>* {
    --bs-table-accent-bg: #ededed !important;
}
.table-hover tbody tr:hover {
    color: #212529;
    background-color: #ededed;
}
.form-group.required label:after {
  content: "*";
  color: red;
}

.custom-breadcrumb{
  font-size: smaller !important;
}
.purchitem{
    background-color: #1b2753;
    padding: 5px 2px 5px 8px;
    border-radius: 3px;
    color: white;
}
.custom-maintitle{
    background-color: #ddeffc;
    padding: 5px 2px 5px 8px;
    border-radius: 3px;
}
.table-hover>tbody>tr:hover>* {
    --bs-table-accent-bg: #ededed !important;
}
.custom_bdr_rds {
  border-radius: 15px !important;
}
.background_color{
  background-color: #f7f7f7 !important;
}
.background_color2{
  background-color: #212529 !important;
  
  
}
.width-custom9{
  width: 100% !important;
}

.bdr-rad{
  border-radius: 12px !important;
}
.bdr-rad2{
  border-radius: 15px !important;
}
.mx-input {
  border-radius: 12px !important;
}

.vs__dropdown-toggle {
      border-radius: 12px !important;
    border-top-left-radius: 12px !important;
    border-top-right-radius: 12px !important;
    border-bottom-right-radius: 12px !important;

}
.vs__dropdown-menu {
      border-radius: 15px !important;
    border-top-left-radius: 15px !important;
    border-top-right-radius: 15px !important;
    border-bottom-right-radius: 15px !important;

}
.form-control{
  border-radius: 12px !important;
}
.form-select{
  border-radius: 12px !important;
}
.modal-content {
  border-radius: 12px !important;
}

.active-status{
  color: #428614;
  background-color: #dbf8cd;
  text-align: center;
  border-radius: 12px;
  padding: 4px;
}

.open-status{
  color: #5612A0;
  background-color: #EEE7FF;
  text-align: center;
  border-radius: 12px;
  padding: 4px;
}
.inprogress-status{
  color: #1B2753;
  background-color: #DDEAFC;
  text-align: center;
  border-radius: 12px;
  padding: 4px;
}
.dormant-status{
  color: #545454;
  background-color: #EDEDED;
  text-align: center;
  border-radius: 12px;
  padding: 4px;
}
.close-status{
  color: #305710;
  background-color: #E8FFC8;
  text-align: center;
  border-radius: 12px;
  padding: 4px;
}
.reopen-status{
  color: #7C330B;
  background-color: #fff4c5;
  text-align: center;
  border-radius: 12px;
  padding: 4px;
}
.pause-status{
  color: #3b0f0f;
  background-color: #f3c4c4;
  text-align: center;
  border-radius: 12px;
  padding: 4px;
}


</style>